module.exports = __webpack_public_path__ + "assets/40fdf158ef2238deed38818ebaf0e1d0.mp3";